import './lang'

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    })

    /**
     * MIX
     */
    $('#main-sidebar-toggle').click(function(e) {
        e.preventDefault()
        $('body').toggleClass('main-sidebar-toggle-active')
    })

    $('.done-button').click(function() {
        if ($(this).hasClass('toggled')) {
            $(this).removeClass('toggled')
            $('.done-button strong').html(lang.get('View completed tasks'))
        } else {
            $(this).addClass('toggled')
            $('.done-button strong').html(lang.get('Hide completed tasks'))
        }
    })

    $('.result-toggle').click(function() {
        if ($(this).hasClass('toggled')) {
            $(this).removeClass('toggled')
            $(this).find('span').html(lang.get('Show evaluation'))
        } else {
            $(this).addClass('toggled')
            $(this).find('span').html(lang.get('Hide evaluation'))
        }
    })

    $('.lesson-photos .gallery-btn').click(function(e) {
        e.preventDefault()
        $('.gallery-toggle').toggleClass('toggled')

        $('.result-toggle').click(function() {
            if ($(this).hasClass('toggled')) {
                $(this).removeClass('toggled')
                $(this).find('span').html(lang.get('Show evaluation'))
            } else {
                $(this).addClass('toggled')
                $(this).find('span').html(lang.get('Hide evaluation'))
            }
        })

        // helper to close closest modal
        $('.modal-close').on('click', function() {
            $(this)
                .closest('.modal')
                .modal('hide')
        })

        if (window.location.hash) {
            const $el = $('a[href="' + window.location.hash + '"]')

            if ($el) {
                $el.click()
                window.location.hash = ''
            }
        }
    })

    /**
     * Parses URL parameters
     */
    $.QueryString = (function(paramsArray) {
        const params = {}

        for (let i = 0; i < paramsArray.length; ++i) {
            const param = paramsArray[i].split('=', 2)

            if (param.length !== 2) continue

            params[param[0]] = decodeURIComponent(param[1].replace(/\+/g, ' '))
        }

        return params
    })(window.location.search.substr(1).split('&'))

    $(document).on('show.bs.modal', '.modal-knowledgebase', function() {
        $('.modal-backdrop').addClass('out')
    })

    $(document).on('hidden.bs.modal', '.modal-knowledgebase', function() {
        $('.modal-backdrop').removeClass('out')
    })
})
